/*
    Add By POOM : 2024-05-20

*/

import React, { useEffect, useState } from "react";

import { Class_ETC_SessionTimeOut } from "../Class/Class_Etc";

import ConfigETC from "../Class/ConfigETC.json";
import { CP_CheckPermission } from "../Class/Class_Permission";



function CV_Overview(props) {
  //#region __ declare variable __

  const isSVOT = CP_CheckPermission("service_list", ["ot"], false, false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [worktime, setWorktime] = useState("-");
  const [overtime, setOvertime] = useState("-");
  const [timeoff_time, setTimeoff_time] = useState("-");

  const [worktime_per, setWorktime_per] = useState("-");
  const [overtime_per, setOvertime_per] = useState("-");
  const [timeoff_time_per, setTimeoff_time_per] = useState("-");

  const [time_wt_charge, setTime_wt_charge] = useState("-");
  const [time_ot_charge, setTime_ot_charge] = useState("-");

  // eslint-disable-next-line
  const [toreviewNo, setToreviewNo] = useState("0");
  const [toapproveNo, setToapproveNo] = useState("0");
  const [approvedNo, setApprovedNo] = useState("0");
  const [rejectNo, setRejectNo] = useState("0");
  const [clearingNo, setClearingNo] = useState("0");
  const [costWT, setCostWT] = useState("0.00");
  const [costOT, setCostOT] = useState("0.00");
  const [costExpExtra, setCostExpExtra] = useState("0.00");
  const [costExpTravel, setCostExpTravel] = useState("0.00");
  const [costExpOther, setCostExpOther] = useState("0.00");

  const [costExpExtraDay, setCostExpExtraDay] = useState("0.00");
  const [costExpTravelDistance, setCostExpTravelDistance] = useState("0.00");

  //#endregion

  //#region __ UseEffect __

  useEffect(() => {
    if (isFirst) {
      BindCV_Summary(function () {
        setIsFirst(false);
        setIsLoadProgress(false);
      });
    }
    // eslint-disable-next-line
  }, [isFirst]);

  //#endregion

  //#region __ Function __

  async function BindCV_Summary(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cus_id: props.cusid,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        props.API_URL + "CustomerView_Overview_Summary",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {

          setWorktime(json.work_time);
          setWorktime_per(json.work_time_per);

          setOvertime(json.over_time);
          setOvertime_per(json.over_time_per);

          setTimeoff_time(json.timeoff_time);
          setTimeoff_time_per(json.timeoff_time_per);

          setTime_wt_charge(json.time_wt_charge);
          setTime_ot_charge(json.time_ot_charge);

          setToreviewNo(json.sum_toreview_str);
          setToapproveNo(json.sum_toapprove_str);
          setApprovedNo(json.sum_approved_str);
          setRejectNo(json.sum_reject_str);
          setClearingNo(json.sum_clearing_str);
          setCostWT(json.sum_cost_wt_str);
          setCostOT(json.sum_cost_ot_str);
          setCostExpExtra(json.sum_cost_exp_extra_str);
          setCostExpTravel(json.sum_cost_exp_travel_str);
          setCostExpOther(json.sum_cost_exp_other_str);

          setCostExpExtraDay(json.sum_cost_exp_extra_day_str);
          setCostExpTravelDistance(json.sum_cost_exp_travel_distance_str);

        }
        if (_callback != null) {
          _callback();
        }
      } else if (json.status_ID === 2) {
        Class_ETC_SessionTimeOut();
      } else {
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      if (_callback != null) {
        _callback();
      }
    }
  }

  //#endregion

  //#region __ Event __

  //#endregion

  return (
    <>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}

      <div>
        {/* Timesheets and cost */}
        <div className="row">
          <div className="col-12 col-sm-12 col-md-9">
            <div className="row">
              <div
                className={
                  isSVOT === true
                    ? "col-12 col-sm-12 col-md-6"
                    : "col-12 col-sm-12 col-md-12"
                }
              >
                <div className="info-box">
                  <span className="info-box-icon bg-primary elevation-1">
                    <i className="far fa-clock" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">WORK TIME</span>
                    <div className="info-box-number">
                      {worktime !== "" && <>{worktime}</>}
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar bg-gray"
                        style={{ width: worktime_per + "%" }}
                      />
                    </div>
                    <span className="progress-description text-muted">
                      <span>
                        {" "}
                        {worktime_per}
                        <small>% of Project time</small>{" "}
                      </span>
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}

              {isSVOT === true && (
                <>
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="info-box mb-3">
                      <span className="info-box-icon bg-info elevation-1">
                        <i className="far fa-lightbulb" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">OVER TIME</span>
                        <div className="info-box-number">
                          {overtime !== "" && <>{overtime}</>}
                        </div>
                        <div className="progress">
                          <div
                            className="progress-bar bg-gray"
                            style={{ width: overtime_per + "%" }}
                          />
                        </div>
                        <span className="progress-description text-muted">
                          <span>
                            {" "}
                            {overtime_per}
                            <small>% of Project time</small>
                          </span>
                        </span>
                      </div>
                      {/* /.info-box-content */}
                    </div>
                    {/* /.info-box */}
                  </div>
                </>
              )}
            </div>

            {/* Timesheet Cost */}
            {props.PermissionCostView && (
              <div className="row">
                <div
                  className={
                    isSVOT === true ? "col-lg-6 col-6" : "col-lg-12 col-12"
                  }
                >
                  {/* small box */}
                  <div className="small-box bg-primary">
                    <div className="inner">
                      <h5>
                        {costWT}
                        <small style={{ fontSize: "50%" }}>
                          <i className="fab fa-btc text-white" />
                        </small>
                        <span className="float-right">
                          <i
                            className="far fa-clock"
                            title="Only Charged tasks"
                          />{" "}
                          {time_wt_charge !== "" && <>{time_wt_charge}</>}{" "}
                        </span>
                      </h5>
                      <span className="text-small mb-0">
                        WORK TIME COST
                        <small> (Only Charged tasks)</small>
                      </span>
                    </div>
                  </div>
                </div>

                {isSVOT === true && (
                  <>
                    <div className="col-lg-6 col-6">
                      {/* small box */}
                      <div className="small-box bg-info">
                        <div className="inner">
                          <h5>
                            {costOT}
                            <small style={{ fontSize: "50%" }}>
                              <i className="fab fa-btc text-white" />
                            </small>
                            <span className="float-right">
                              <i
                                className="far fa-lightbulb"
                                title="Only Charged tasks"
                              />{" "}
                              {time_ot_charge !== "" && <>{time_ot_charge}</>}{" "}
                            </span>
                          </h5>
                          <span className="text-small mb-0">
                            OVER TIME COST
                            <small> (Only Charged tasks)</small>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                {/* Widget: user widget style 1 */}
                <div className="card card-widget widget-user">
                  {/* Add the bg color to the header using any of the bg-* classes */}
                  <div className="card-header">
                    <h6 className="widget-user-desc text-center">EXPENSES</h6>
                  </div>

                  <div className="pt-1">
                    <div className="row">
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpExtra}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            Per diem allowances
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpTravel}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            TRAVEL
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpOther}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            OTHER
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>

                  <div className="pt-1">
                    <div className="row">
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpExtraDay}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            Per diem allowances (day * rate)
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpTravelDistance}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            TRAVEL DISTANCE (km * rate)
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4"></div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>
                </div>
                {/* /.info-box */}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-3">
            <div className="info-box mb-3">
              <span className="info-box-icon bg-gray elevation-1">
                <i className="far fa-pause-circle" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">TIME OFF</span>
                <span className="info-box-number">
                  {timeoff_time !== "" && <>{timeoff_time}</>}
                </span>
                <div className="progress">
                  <div
                    className="progress-bar bg-gray"
                    style={{ width: timeoff_time_per + "%" }}
                  />
                </div>
                <span className="progress-description text-muted">
                  <span>
                    {" "}
                    {timeoff_time_per}
                    <small>% of Project time</small>
                  </span>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            <div className="card bg-light-gray">
              <div className="card-body p-0">
                <ul className="list-group">
                  <li className="list-group-item p-2">
                    <span>REJECT</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-red btn-xs p-1"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_Reject_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="far fa-calendar-times" />
                        </span>
                        <span className="badge text-biger">{rejectNo}</span>
                      </a>
                    </span>
                  </li>
                  <li className="list-group-item p-2">
                    <span>to REVIEW</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-ToReview btn-xs p-1 col-sm-12"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_ToReview_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="fas fa-chalkboard-teacher" />
                        </span>
                        <span className="badge text-biger">{toreviewNo}</span>
                      </a>
                    </span>
                  </li>
                  <li className="list-group-item  p-2">
                    <span>to APPROVE</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-ToApprove btn-xs p-1 col-sm-12"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_ToApprove_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="fas fa-user-check" />
                        </span>
                        <span className="badge text-biger">{toapproveNo}</span>
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-box mb-3">
              <span className="info-box-icon bg-Approved elevation-1">
                <i className="fas fa-check" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  APPROVED
                  <a
                    href="#!"
                    className="text-smaller text-muted float-right align-top"
                    data-toggle="pill"
                    title="Click for view detail"
                    onClick={() =>
                      props.onclick_overview_status(ConfigETC.TS_Approved_Value)
                    }
                  >
                    More info <i className="fas fa-arrow-circle-right" />
                  </a>
                </span>
                <span className="info-box-number">
                  <big>{approvedNo}</big>{" "}
                  <small className="text-smaller text-muted">transaction</small>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>

            <div className="info-box mb-3">
              <span className="info-box-icon bg-Clearing elevation-1">
                <i className="fas fa-check-double" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  CLEARED
                  <a
                    href="#!"
                    className="text-smaller text-muted float-right align-top"
                    data-toggle="pill"
                    title="Click for view detail"
                    onClick={() =>
                      props.onclick_overview_status(ConfigETC.TS_Clearing_Value)
                    }
                  >
                    More info <i className="fas fa-arrow-circle-right" />
                  </a>
                </span>
                <span className="info-box-number">
                  <big>{clearingNo}</big>{" "}
                  <small className="text-smaller text-muted">transaction</small>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
          </div>
        </div>

        {/* /.row */}
      </div>
    </>
  );
}

export default CV_Overview;
